import { Navigate, useSearchParams } from 'react-router';
import { declareFlightsState, declareSourceState } from '@/routes/declare/declare-route.state';

// /cases/new — ABSORBED into the declare flow (unified-declare §1a, decision 1).
//
// Everything with a flight now declares a disruption (one case per flight), so the
// old case form — schedule search, predictor list, PNR subset, scope — lives on as
// the declare flow on /express. Only loose PNRs (no flight) stay a standalone case,
// and that is the flow's own «PNRs sueltos» source.
//
// The route stays registered so bookmarks and old links keep landing somewhere
// useful, and redirects with `replace` (Back does not bounce the operator into the
// redirect again):
//   ?flight=<urn>  → step 2 with that flight already chosen (the old deep link);
//   anything else  → step 1 on the departures board.
// Router state, never query params, past this point (`declare-route.state.ts`).

export function CaseNewRoute() {
  const [search] = useSearchParams();
  const flightUrn = search.get('flight')?.trim();
  return (
    <Navigate
      to="/express"
      replace
      state={flightUrn ? declareFlightsState([flightUrn]) : declareSourceState('BOARD')}
    />
  );
}
